import { readonly, ref } from "vue";

export type ThemeName = "light" | "dark";

/* 站点视觉只有深色一套（3D 场景、粒子层、WebGL 背景都是按深色设计的），
   所以这里不做明暗切换，只负责把当前主题正确地写到 DOM 上，
   让 Arco 组件库切到对应的变量组。 */
const theme = ref<ThemeName>("dark");

const apply = (value: ThemeName) => {
  theme.value = value;
  const root = document.documentElement;
  root.dataset.theme = value;
  root.style.colorScheme = value;
  /* Arco 的暗色变量挂在 body[arco-theme='dark'] 上，必须显式写上，
     否则 arco.css 里 body{} 的浅色默认值会先于 :root 生效。 */
  document.body?.setAttribute("arco-theme", value);
};

let initialized = false;

export const initializeTheme = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  apply("dark");
};

export const useTheme = () => {
  initializeTheme();
  return { theme: readonly(theme), initializeTheme };
};
